import "./NavBar-style.css";
import { Link } from "react-router-dom";
function NavBar() {
  return (
    <div className="navBar">
      <Link to="/">HOME</Link>
      <Link to="/videos">VIDEOS</Link>
    </div>
  );
}

export default NavBar;
